const fixedOptions = {
  galleryLayout: 5,
  cubeType: "fit",
  scrollSnap: true,
  videoPlay: "onClick",
  videoLoop: false,
  videoSound: true,
  hidePlay: false,
  showVideoControls: true,
  showVideoPlayButton: true,
  allowSocial: false,
  loveButton: false,
  allowTitle: true,
  defaultShowInfoExpand: 1,
  floatingImages: 0,
  allowContextMenu: true
};

export { fixedOptions };
//# sourceMappingURL=consts.js.map
